import { fetchData, updateUserWorkspace } from "@client";

export async function switchWorkspaceQuery(uuid) {
  const res = await fetchData(`/workspace/${uuid}`);
  await updateUserWorkspace(res.results.uuid);
  return res.results;
}
